import React from "react";
import "./register.css";
import registerPic from "./register.jpg";
import Tab from "./Tabs";
import CurrentRegister from "./LicensedSurveyors";
import ApprovedSurv from "./ApprovedSurveyors";

function Register() {
  const tabs = [
    {
      id: 1,
      label: "Licensed Surveyors",
      content: <CurrentRegister />,
    },
    {
      id: 2,
      label: "Approved Assistants",
      content: <ApprovedSurv />,
    },
  ];

  return (
    <div>
      <div className="relative mb-12">
        <img
          className="h-96 w-full object-cover object-center rounded-b-2xl shadow-2xl"
          src={registerPic}
          alt="A beautiful landscape"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent rounded-b-2xl"></div>
        <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-10 flex flex-col items-center w-full px-4">
          <h1
            className="text-4xl md:text-5xl font-extrabold text-white mb-3 text-center tracking-tight uppercase"
          >
            Updated Register
          </h1>
        </div>
      </div>

      {/* tabs */}
      <div className="px-20">
        <p><b className="text-[#3d0707]">A Licensed Surveyor</b> is a surveyor duly licensed as a surveyor under or by virtue of the provisions of the Survey Act Cap 299.</p>

        <p><b className="text-[#3d0707]">Approved Assistant</b> is any person other than a licensed surveyor who assists a licensed surveyor in the execution of field surveys, but does not include skilled and semi-skilled chainmen and laborers. As per the Survey Regulations of 1994, No licensed surveyor shall employ an approved assistant without the written approval of the Board.</p>

        <p className="pt-3"><b className="text-red-500 underline underline-offset-2">Note:</b> The information contained in this register is up to date. Click on <b className="text-[#3d0707] underline underline-offset-2">surveyor's name</b> to view their profile.</p>

        <div className="flex justify-center my-4">
          <Tab tabs={tabs} />
        </div>
      </div>
    </div>
  );
}

export default Register;
